import { PluginConfiguration } from ".";

export const filesPlugin: PluginConfiguration = {
    icon: 'file',
    name: 'Document Library - Files',
    pluginName: 'Files',
    url: 'document-library/Files.min.js',
	documentation: 'document-library/index.html',
    properties: 'document-library/files.properties.json'
}